import React from "react";

export function LogoMark({ size = 32 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="12" fill="#0F172A" />
      <path d="M11 26L18 18.5L23 23L30 14" stroke="#6366F1" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="30" cy="14" r="2.6" fill="#818CF8" />
    </svg>
  );
}

export function Logo({ size = 32, className = "", tagline = false }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} />
      <div className="leading-none">
        <span className="font-heading font-bold text-xl tracking-tight text-slate-900 block">
          Inves<span className="text-indigo-600">y</span>
        </span>
        {tagline && (
          <span className="text-[10px] uppercase tracking-[0.14em] text-slate-400 mt-1 block">
            Investments made Easy
          </span>
        )}
      </div>
    </div>
  );
}
